var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-search';
                    var viewUrl = 'sprite.svg#view-icon-search';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 21 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };